/**
 * Copyright (c) 2024, Mint Metrics Pty Ltd All rights reserved. BSD 3-Clause License. https://github.com/mint-metrics/mojito/blob/master/LICENSE
 * Copyright (c) 2010, James Yu. https://github.com/jamesyu/cohorts/blob/master/LICENSE
 * Copyright (c) 2005-2017, JS Foundation All rights reserved. https://dojotoolkit.org/license.html
 * Copyright (c) 2011 Sebastian Tschan, https://blueimp.net
 */

(function () {
    function waitForJQuery(callback) {
        Mojito.utils.waitUntil(
            function () {
                return window.jQuery;
            },
            callback,
            20 * 1000
        );
    }

    function renderPrices(container) {
        let pricesHolder = container.querySelector('.prices');
        if (pricesHolder) {
            pricesHolder.remove();
        }

        const priceNodes = container.querySelectorAll('.product__price');
        let tempNode = container.querySelector('.temp-prices');
        pricesHolder = document.createElement('div');
        pricesHolder.className = 'prices';

        if (tempNode) {
            tempNode.insertAdjacentElement('beforebegin', pricesHolder);
        } else {
            if (priceNodes[0].parentNode.tagName === 'SPAN') {
                priceNodes[0].parentNode.insertAdjacentElement('beforebegin', pricesHolder);
            } else {
                priceNodes[0].insertAdjacentElement('beforebegin', pricesHolder);
            }

            tempNode = document.createElement('div');
            tempNode.className = 'temp-prices';
            pricesHolder.insertAdjacentElement('afterend', tempNode);
            tempNode.insertAdjacentElement('beforeend', priceNodes[0]);

            if (priceNodes[1]) {
                tempNode.insertAdjacentElement('beforeend', priceNodes[1]);
            } else {
                priceNodes[0].classList.add('on-sale');
            }

            const savingsNode = container.querySelector('.product__price-savings:not(.hide)');
            if (savingsNode) {
                tempNode.insertAdjacentElement('beforeend', savingsNode);
            }
        }

        const priceNodesArray = tempNode.querySelectorAll('span');
        priceNodesArray.forEach((node) => {
            const priceNode = document.createElement('span');
            if (node.classList.contains('on-sale')) {
                priceNode.className = 'price-holder on-sale';
            } else if (node.classList.contains('product__price-savings')) {
                priceNode.className = 'price-holder savings';
            } else {
                priceNode.className = 'price-holder compare';
            }

            pricesHolder.insertAdjacentElement('beforeend', priceNode);
            const priceParts = node.textContent.trim().split('.');
            priceNode.innerHTML = `
                <span class="currency">$</span>
                <span class="number">${priceParts[0].replace('Save $', '').replace('$', '')}</span>
                <span class="decimal">${priceParts[1] || ''}</span>`;
        });

        const soldoutBtn = document.querySelector('.product-section:not(.is-modal) button.btn--full[type="submit"]');
        if (soldoutBtn && soldoutBtn.textContent.toUpperCase().includes('SOLD OUT')) {
            container.classList.add('sold-out');
            let soldOutNode = pricesHolder.querySelector('.sold-out-tag');
            if (!soldOutNode) {
                soldOutNode = document.createElement('div');
                soldOutNode.className = 'sold-out-tag';
                soldOutNode.innerHTML = 'SOLD OUT';
                pricesHolder.insertAdjacentElement('beforeend', soldOutNode);
            }
        } else {
            container.classList.remove('sold-out');
            const soldOutNode = pricesHolder.querySelector('.sold-out-tag');
            if (soldOutNode) {
                soldOutNode.remove();
            }
        }
    }

    function watchVariantChange(container) {
        waitForJQuery(function () {
            const productSection = jQuery(container).closest('.product-section');
            productSection.on('variantChange.product-' + productSection.attr('data-section-id'), function () {
                setTimeout(() => {
                    renderPrices(container);
                }, 300);
            });
        });
    }

    function doTransform(container) {
        const titleNode = container.querySelector('.h2.product-single__title');
        if (!titleNode || !titleNode.previousElementSibling || !titleNode.previousElementSibling.classList.contains('product-single__vendor')) {
            return;
        }

        titleNode.previousElementSibling.insertAdjacentElement('beforebegin', titleNode);
        const vendorRatingHolder = document.createElement('div');
        vendorRatingHolder.className = 'vendor-rating';
        titleNode.insertAdjacentElement('afterend', vendorRatingHolder);

        vendorRatingHolder.insertAdjacentElement('beforeend', container.querySelector('.product-single__vendor'));
        const reviewNode = container.querySelector('.okeReviews');
        if (reviewNode) {
            vendorRatingHolder.insertAdjacentElement('beforeend', reviewNode);
        }

        renderPrices(container);
        watchVariantChange(container);

        if (!container.querySelectorAll('.variant-wrapper--dropdown').length) {
            container.classList.add('no-variants');
        }
    }

    function treatment() {
        Mojito.utils.waitForElement('.product-single__meta:not(.main)', function (element) {
            const productNode = element;
            if (productNode.classList.contains('main')) {
                return;
            }

            productNode.classList.add('main');
            setTimeout(() => {
                Mojito.utils.waitForElement('.main .product__price', () => {
                    doTransform(productNode);
                });
            }, 10);
        });
    }

    function trigger() {
        if (!/\/products\//gi.test(location.pathname)) {
            return;
        }

        treatment();
    }

    trigger();
})();
